define("shared/utils/media-adjustments/bytes-pretty-string", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.bytesPrettyString = bytesPrettyString;
  _exports.bytesPrettyStringNearThreshold = bytesPrettyStringNearThreshold;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  const UNITS = ['B', 'KB', 'MB', 'GB'];
  const DEFAULT_MAX_DECIMAL_PLACES = 5;

  /** Largest unit (index into {@link UNITS}) that keeps `bytes` >= 1, capped at GB. */
  function unitIndexFor(bytes) {
    return Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), UNITS.length - 1);
  }
  function scaleToUnit(bytes, unitIndex) {
    return bytes / 1024 ** unitIndex;
  }
  function bytesPrettyString(bytes) {
    if (bytes <= 0) {
      return '0 B';
    }
    const unitIndex = unitIndexFor(bytes);
    const value = scaleToUnit(bytes, unitIndex);
    return `${value >= 10 || unitIndex === 0 ? Math.round(value) : value.toFixed(1)} ${UNITS[unitIndex]}`;
  }
  function roundToDecimals(value, decimals) {
    const factor = 10 ** decimals;
    return Math.round(value * factor) / factor;
  }

  /**
   * Formats a byte count relative to a nearby threshold, using the fewest decimal places needed
   * to keep the value visually distinct from the threshold. This avoids contradictory copy where
   * a size that is genuinely over (or under) a limit rounds to the same string as the limit.
   *
   * Both the value and the threshold are rendered in the unit derived from the threshold, so they
   * share a scale and remain directly comparable.
   *
   * @param bytes The size to format, in bytes.
   * @param thresholdBytes The reference threshold (e.g. a file-size limit), in bytes.
   * @param maxDecimalPlaces The most decimal places to show before giving up on distinctness.
   * @returns The formatted size string (e.g. "20.0001 MB").
   */
  function bytesPrettyStringNearThreshold(bytes, thresholdBytes) {
    let maxDecimalPlaces = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_MAX_DECIMAL_PLACES;
    if (bytes <= 0) {
      return '0 B';
    }
    const unitIndex = unitIndexFor(thresholdBytes);
    const value = scaleToUnit(bytes, unitIndex);
    const threshold = scaleToUnit(thresholdBytes, unitIndex);
    for (let decimals = 0; decimals <= maxDecimalPlaces; decimals++) {
      if (roundToDecimals(value, decimals) !== roundToDecimals(threshold, decimals)) {
        return `${roundToDecimals(value, decimals)} ${UNITS[unitIndex]}`;
      }
    }
    return `${roundToDecimals(value, 0)} ${UNITS[unitIndex]}`;
  }
});